module.exports = __webpack_public_path__ + "img/drawing3.58278ad0.jpg";